<template>
  <div id="StudyVisualIdentity" class="study">
    <div class="container-fluid head" style="background-color: #F3A797">
      <Header />
      
      <h1>Visual Identity and Logo Design</h1>
    </div>

    <div class="container">

      <div class="row">
        <div class="col-12">
          <h2 class="text-center">LOGO DESIGN - OISHI</h2>
          <p>
            Client branding identity for OISHI &#8212; a japanese restaurant.<br/>
            The name "Oishi" comes from the Japanese word "おいしい" meaning "delicious food".<br/>
            I used a modern sans-serif typeface that is clean, simple and highly readable. I replaced the macron line with a leaf to give it a natural food look.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <img src="/images/VisualIdentity/oishi-logo.png" width="100%" />
          <img src="/images/VisualIdentity/oishi-packaging.png" width="100%" style="margin-top: 100px;"/>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2 class="text-center">LOGO DESIGN - KESHOHIN</h2>
          <p>
            Client branding identity for KESHOHIN &#8212; a cosmetic ecommerce.<br/>
            The name "Keshoshin" comes from the Japanese word "化粧品" meaning "cosmetics".<br/>
            I used Monserrat, a sans-serif typeface. I highlighted the letter K to give a relation with K-Beauty since this store also sells Korean products.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <img src="/images/VisualIdentity/logo-keshohin.png" width="100%" style="max-width:500px; display: block; margin: auto;" />
          <img src="/images/VisualIdentity/keshohin-sublogo.png" width="100%" style="margin-top: 100px;"/>
          <img src="/images/VisualIdentity/ke-bag1.png" width="100%" style="margin-top: 50px;"/>
          <img src="/images/VisualIdentity/ke-bag2.png" width="100%" style="margin-top: 10px;"/>
          <img src="/images/VisualIdentity/ke-bag3.png" width="100%" style="margin-top: 10px;"/>
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyVisualIdentity",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () {},
};
</script>

<style lang="scss">
#StudyVisualIdentity {
  h2 {
    color: #46478a;
  }
}
</style>